export const ZoofrenzFirstClassPass = {
  contractName: "ZoofrenzFirstClassPass",
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "initMinter",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "maxAmountPerMint",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "maxCollection",
          type: "uint256",
        },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "baseURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getApproved",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getMaxSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "mint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "minter",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "nextOwnerToExplicitlySet",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      name: "originalTokenId",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "ownerOf",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "setApprovalForAll",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "string",
          name: "newURI",
          type: "string",
        },
      ],
      name: "setBaseURI",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "newSupply",
          type: "uint256",
        },
      ],
      name: "setMaxSupply",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newMinter",
          type: "address",
        },
      ],
      name: "setMinter",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4",
        },
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenOfOwnerByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "tokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
  metadata:
    '{"compiler":{"version":"0.8.16+commit.07a7930e"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"address","name":"initMinter","type":"address"},{"internalType":"uint256","name":"maxAmountPerMint","type":"uint256"},{"internalType":"uint256","name":"maxCollection","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMaxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"minter","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nextOwnerToExplicitlySet","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"originalTokenId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"newURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newSupply","type":"uint256"}],"name":"setMaxSupply","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newMinter","type":"address"}],"name":"setMinter","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"kind":"dev","methods":{"approve(address,uint256)":{"details":"See {IERC721-approve}."},"balanceOf(address)":{"details":"See {IERC721-balanceOf}."},"getApproved(uint256)":{"details":"See {IERC721-getApproved}."},"isApprovedForAll(address,address)":{"details":"See {IERC721-isApprovedForAll}."},"name()":{"details":"See {IERC721Metadata-name}."},"owner()":{"details":"Returns the address of the current owner."},"ownerOf(uint256)":{"details":"See {IERC721-ownerOf}."},"renounceOwnership()":{"details":"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner."},"safeTransferFrom(address,address,uint256)":{"details":"See {IERC721-safeTransferFrom}."},"safeTransferFrom(address,address,uint256,bytes)":{"details":"See {IERC721-safeTransferFrom}."},"setApprovalForAll(address,bool)":{"details":"See {IERC721-setApprovalForAll}."},"supportsInterface(bytes4)":{"details":"See {IERC165-supportsInterface}."},"symbol()":{"details":"See {IERC721Metadata-symbol}."},"tokenByIndex(uint256)":{"details":"See {IERC721Enumerable-tokenByIndex}."},"tokenOfOwnerByIndex(address,uint256)":{"details":"See {IERC721Enumerable-tokenOfOwnerByIndex}. This read function is O(collectionSize). If calling from a separate contract, be sure to test gas first. It may also degrade with extremely large collection sizes (e.g >> 10000), test for your use case."},"tokenURI(uint256)":{"details":"See {IERC721Metadata-tokenURI}."},"totalSupply()":{"details":"See {IERC721Enumerable-totalSupply}."},"transferFrom(address,address,uint256)":{"details":"See {IERC721-transferFrom}."},"transferOwnership(address)":{"details":"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."}},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}},"settings":{"compilationTarget":{"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/contracts/ZoofrenzFirstClassPass/ZoofrenzFirstClassPass.sol":"ZoofrenzFirstClassPass"},"evmVersion":"london","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":200},"remappings":[]},"sources":{"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/contracts/ZoofrenzFirstClassPass/ERC721A_old.sol":{"keccak256":"0x5f20e2e4cf706eaa11addfe32580ee7daebd64f58422f224844bf61295192126","license":"MIT","urls":["bzz-raw://85fdd25aa17617dd527a26e693d7b4f0836f99889cce89160f6a87aa4918be46","dweb:/ipfs/QmS3toieEVnmviZu3JJqWJvartyj6zVV68G3Psr1Un5pKo"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/contracts/ZoofrenzFirstClassPass/ZoofrenzFirstClassPass.sol":{"keccak256":"0x78b5f50bf0254d2ec6fcd472176b781ee049da87a1b5c573f58ed7801a006e8d","license":"MIT","urls":["bzz-raw://93ef7f197873cfa79bfd5b7b3db98799e586210dace6ba16fa151d8e18f4e113","dweb:/ipfs/QmTpmNy5emuD8KzRsmQMycxsvK3c3bK9Nh61Tg8TwsBzzG"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/access/Ownable.sol":{"keccak256":"0x24e0364e503a9bbde94c715d26573a76f14cd2a202d45f96f52134ab806b67b9","license":"MIT","urls":["bzz-raw://e12cbaa7378fd9b62280e4e1d164bedcb4399ce238f5f98fc0eefb7e50577981","dweb:/ipfs/QmXRoFGUgfsaRkoPT5bxNMtSayKTQ8GZATLPXf69HcRA51"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/security/ReentrancyGuard.sol":{"keccak256":"0x0e9621f60b2faabe65549f7ed0f24e8853a45c1b7990d47e8160e523683f3935","license":"MIT","urls":["bzz-raw://287a2f8d5814dd0f05f22b740f18ca8321acc21c9bd03a6cb2203ea626e2f3f2","dweb:/ipfs/QmZRQv9iuwU817VuqkA2WweiaibKii69x9QxYBBEfbNEud"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/token/ERC721/IERC721.sol":{"keccak256":"0x0d4de01fe5360c38b4ad2b0822a12722958428f5138a7ff47c1720eb6fa52bba","license":"MIT","urls":["bzz-raw://77724cecdfba8814632ab58737c2b0f2d4ad2d532bc614aee559b5593c1152f0","dweb:/ipfs/QmUcE6gXyv7CQh4sUdcDABYKGTovTe1zLMZSEq95nkc3ph"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/token/ERC721/IERC721Receiver.sol":{"keccak256":"0xa82b58eca1ee256be466e536706850163d2ec7821945abd6b4778cfb3bee37da","license":"MIT","urls":["bzz-raw://6e75cf83beb757b8855791088546b8337e9d4684e169400c20d44a515353b708","dweb:/ipfs/QmYvPafLfoquiDMEj7CKHtvbgHu7TJNPSVPSCjrtjV8HjV"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/token/ERC721/extensions/IERC721Enumerable.sol":{"keccak256":"0xd1556954440b31c97a142c6ba07d5cade45f96fafd52091d33a14ebe365aecbf","license":"MIT","urls":["bzz-raw://26fef835622b46a5ba08b3ef6b46a22e94b5f285d0f0fb66b703bd30217d2c34","dweb:/ipfs/QmZ548qdwfL1qF7aXz3xh1GCdTiST81kGGuKRqVUfYmPZR"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/token/ERC721/extensions/IERC721Metadata.sol":{"keccak256":"0x75b829ff2f26c14355d1cba20e16fe7b29ca58eb5fef665ede48bc0f9c6c74b9","license":"MIT","urls":["bzz-raw://a0a107160525724f9e1bbbab031defc2f298296dd9e331f16a6f7130cec32146","dweb:/ipfs/QmemujxSd7gX8A9M8UwmNbz4Ms3U9FG9QfudUgxwvTmPWf"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/utils/Address.sol":{"keccak256":"0x2ccf9d2313a313d41a791505f2b5abfdc62191b5d4334f7f7a82691c088a1c87","license":"MIT","urls":["bzz-raw://b3a57d0854b2fdce6ebff933a48dca2445643d1eccfc27f00292e937f26c6a58","dweb:/ipfs/QmW45rZooS9TqR4YXUbjRbtf2Bpb5ouSarBvfW1LdGprvV"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/utils/Context.sol":{"keccak256":"0xe2e337e6dde9ef6b680e07338c493ebea1b5fd09b43424112868e9cc1706bca7","license":"MIT","urls":["bzz-raw://6df0ddf21ce9f58271bdfaa85cde98b200ef242a05a3f85c2bc10a8294800a92","dweb:/ipfs/QmRK2Y5Yc6BK7tGKkgsgn3aJEQGi5aakeSPZvS65PV8Xp3"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/utils/Strings.sol":{"keccak256":"0x32c202bd28995dd20c4347b7c6467a6d3241c74c8ad3edcbb610cd9205916c45","license":"MIT","urls":["bzz-raw://8179c356adb19e70d6b31a1eedc8c5c7f0c00e669e2540f4099e3844c6074d30","dweb:/ipfs/QmWFbivarEobbqhS1go64ootVuHfVohBseerYy9FTEd1W2"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/utils/introspection/ERC165.sol":{"keccak256":"0xd10975de010d89fd1c78dc5e8a9a7e7f496198085c151648f20cba166b32582b","license":"MIT","urls":["bzz-raw://fb0048dee081f6fffa5f74afc3fb328483c2a30504e94a0ddd2a5114d731ec4d","dweb:/ipfs/QmZptt1nmYoA5SgjwnSgWqgUSDgm4q52Yos3xhnMv3MV43"]},"/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/utils/introspection/IERC165.sol":{"keccak256":"0x447a5f3ddc18419d41ff92b3773fb86471b1db25773e07f877f548918a185bf1","license":"MIT","urls":["bzz-raw://be161e54f24e5c6fae81a12db1a8ae87bc5ae1b0ddc805d82a1440a68455088f","dweb:/ipfs/QmP7C3CHdY9urF4dEMb9wmsp1wMxHF6nhA2yQE5SKiPAdy"]}},"version":1}',
  bytecode:
    "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",
  deployedBytecode:
    "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",
  sourceMap:
    "341:1646:1:-:0;;;1943:1:0;1912:32;;14776:1;14734:43;;527:295:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;2879:480:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;2879:480:0;;;728:16:1;758:13;3070:1:0;3052:15;:19;3031:112;;;;-1:-1:-1;;;3031:112:0;;633:2:13;3031:112:0;;;615:21:13;672:2;652:18;;;645:30;711:34;691:18;;;684:62;-1:-1:-1;;;762:18:13;;;755:44;816:19;;3031:112:0;;;;;;;;;3177:1;3161:13;:17;3153:69;;;;-1:-1:-1;;;3153:69:0;;1048:2:13;3153:69:0;;;1030:21:13;1087:2;1067:18;;;1060:30;1126:34;1106:18;;;1099:62;-1:-1:-1;;;1177:18:13;;;1170:37;1224:19;;3153:69:0;846:403:13;3153:69:0;3232:5;:13;3240:5;3232;:13;:::i;:::-;-1:-1:-1;3255:7:0;:17;3265:7;3255;:17;:::i;:::-;-1:-1:-1;3282:28:0;;;;;3320:32;;-1:-1:-1;921:32:2;;-1:-1:-1;719:10:9;921:18:2;:32::i;:::-;-1:-1:-1;;1701:1:3;1806:7;:22;796:6:1::1;:19:::0;;-1:-1:-1;;;;;;796:19:1::1;-1:-1:-1::0;;;;;796:19:1;;;::::1;::::0;;;::::1;::::0;;341:1646;;2270:187:2;2362:6;;;-1:-1:-1;;;;;2378:17:2;;;-1:-1:-1;;;;;;2378:17:2;;;;;;;2410:40;;2362:6;;;2378:17;2362:6;;2410:40;;2343:16;;2410:40;2333:124;2270:187;:::o;14:412:13:-;102:6;110;118;171:2;159:9;150:7;146:23;142:32;139:52;;;187:1;184;177:12;139:52;213:16;;-1:-1:-1;;;;;258:31:13;;248:42;;238:70;;304:1;301;294:12;238:70;372:2;357:18;;351:25;416:2;401:18;;;395:25;327:5;;351:25;;-1:-1:-1;395:25:13;14:412;-1:-1:-1;;;14:412:13:o;1254:127::-;1315:10;1310:3;1306:20;1303:1;1296:31;1346:4;1343:1;1336:15;1370:4;1367:1;1360:15;1386:380;1465:1;1461:12;;;;1508;;;1529:61;;1583:4;1575:6;1571:17;1561:27;;1529:61;1636:2;1628:6;1625:14;1605:18;1602:38;1599:161;;1682:10;1677:3;1673:20;1670:1;1663:31;1717:4;1714:1;1707:15;1745:4;1742:1;1735:15;1599:161;;1386:380;;;:::o;1897:545::-;1999:2;1994:3;1991:11;1988:448;;;2035:1;2060:5;2056:2;2049:17;2105:4;2101:2;2091:19;2175:2;2163:10;2159:19;2156:1;2152:27;2146:4;2142:38;2211:4;2199:10;2196:20;2193:47;;;-1:-1:-1;2234:4:13;2193:47;2289:2;2284:3;2280:12;2277:1;2273:20;2267:4;2263:31;2253:41;;2344:82;2362:2;2355:5;2352:13;2344:82;;;2407:17;;;2388:1;2377:13;2344:82;;;2348:3;;;1988:448;1897:545;;;:::o;2618:1352::-;2738:10;;-1:-1:-1;;;;;2760:30:13;;2757:56;;;2793:18;;:::i;:::-;2822:97;2912:6;2872:38;2904:4;2898:11;2872:38;:::i;:::-;2866:4;2822:97;:::i;:::-;2974:4;;3038:2;3027:14;;3055:1;3050:663;;;;3757:1;3774:6;3771:89;;;-1:-1:-1;3826:19:13;;;3820:26;3771:89;-1:-1:-1;;2575:1:13;2571:11;;;2567:24;2563:29;2553:40;2599:1;2595:11;;;2550:57;3873:81;;3020:944;;3050:663;1844:1;1837:14;;;1881:4;1868:18;;-1:-1:-1;;3086:20:13;;;3204:236;3218:7;3215:1;3212:14;3204:236;;;3307:19;;;3301:26;3286:42;;3399:27;;;;3367:1;3355:14;;;;3234:19;;3204:236;;;3208:3;3468:6;3459:7;3456:19;3453:201;;;3529:19;;;3523:26;-1:-1:-1;;3612:1:13;3608:14;;;3624:3;3604:24;3600:37;3596:42;3581:58;3566:74;;3453:201;-1:-1:-1;;;;;3700:1:13;3684:14;;;3680:22;3667:36;;-1:-1:-1;2618:1352:13:o;:::-;341:1646:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;",
  deployedSourceMap:
    "341:1646:1:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5024:410:0;;;;;;:::i;:::-;;:::i;:::-;;;565:14:13;;558:22;540:41;;528:2;513:18;5024:410:0;;;;;;;;6920:98;;;:::i;:::-;;;;;;;:::i;443:21:1:-;;;;;-1:-1:-1;;;;;443:21:1;;;;;;-1:-1:-1;;;;;1409:32:13;;;1391:51;;1379:2;1364:18;443:21:1;1245:203:13;8555:280:0;;;;;;:::i;:::-;;:::i;8091:403::-;;;;;;:::i;:::-;;:::i;:::-;;3430:98;3483:7;3509:12;3430:98;;;2221:25:13;;;2209:2;2194:18;3430:98:0;2075:177:13;9539:156:0;;;;;;:::i;:::-;;:::i;470:50:1:-;;;;;;:::i;:::-;;;;;;;;;;;;;;4116:841:0;;;;;;:::i;:::-;;:::i;1131:303:1:-;;;;;;:::i;:::-;;:::i;9761:171:0:-;;;;;;:::i;:::-;;:::i;1033:92:1:-;1104:14;1033:92;;3600:220:0;;;;;;:::i;:::-;;:::i;1777:96:1:-;;;;;;:::i;:::-;;:::i;6736:122:0:-;;;;;;:::i;:::-;;:::i;416:21:1:-;;;:::i;924:103::-;;;;;;:::i;:::-;;:::i;5493:252:0:-;;;;;;:::i;:::-;;:::i;1668:101:2:-;;;:::i;1036:85::-;1108:6;;-1:-1:-1;;;;;1108:6:2;1036:85;;7082:102:0;;;:::i;8902:303::-;;;;;;:::i;:::-;;:::i;9998:344::-;;;;;;:::i;:::-;;:::i;1440:331:1:-;;;;;;:::i;:::-;;:::i;14734:43:0:-;;;;;;9271:206;;;;;;:::i;:::-;-1:-1:-1;;;;;9435:25:0;;;9408:4;9435:25;;;:18;:25;;;;;;;;:35;;;;;;;;;;;;;;;9271:206;1918:198:2;;;;;;:::i;:::-;;:::i;828:90:1:-;;;;;;:::i;:::-;;:::i;5024:410:0:-;5166:4;-1:-1:-1;;;;;;5205:40:0;;-1:-1:-1;;;5205:40:0;;:104;;-1:-1:-1;;;;;;;5261:48:0;;-1:-1:-1;;;5261:48:0;5205:104;:170;;;-1:-1:-1;;;;;;;5325:50:0;;-1:-1:-1;;;5325:50:0;5205:170;:222;;;-1:-1:-1;;;;;;;;;;937:40:11;;;5391:36:0;5186:241;5024:410;-1:-1:-1;;5024:410:0:o;6920:98::-;6974:13;7006:5;6999:12;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6920:98;:::o;8555:280::-;8655:7;8699:16;8707:7;10645:4;10678:12;-1:-1:-1;10668:22:0;10588:109;8699:16;8678:108;;;;-1:-1:-1;;;8678:108:0;;5857:2:13;8678:108:0;;;5839:21:13;5896:2;5876:18;;;5869:30;5935:34;5915:18;;;5908:62;-1:-1:-1;;;5986:18:13;;;5979:43;6039:19;;8678:108:0;;;;;;;;;-1:-1:-1;8804:24:0;;;;:15;:24;;;;;;-1:-1:-1;;;;;8804:24:0;;8555:280::o;8091:403::-;8163:13;8179:24;8195:7;8179:15;:24::i;:::-;8163:40;;8227:5;-1:-1:-1;;;;;8221:11:0;:2;-1:-1:-1;;;;;8221:11:0;;8213:58;;;;-1:-1:-1;;;8213:58:0;;6271:2:13;8213:58:0;;;6253:21:13;6310:2;6290:18;;;6283:30;6349:34;6329:18;;;6322:62;-1:-1:-1;;;6400:18:13;;;6393:32;6442:19;;8213:58:0;6069:398:13;8213:58:0;719:10:9;-1:-1:-1;;;;;8303:21:0;;;;:62;;-1:-1:-1;8328:37:0;8345:5;719:10:9;9271:206:0;:::i;8328:37::-;8282:166;;;;-1:-1:-1;;;8282:166:0;;6674:2:13;8282:166:0;;;6656:21:13;6713:2;6693:18;;;6686:30;6752:34;6732:18;;;6725:62;6823:27;6803:18;;;6796:55;6868:19;;8282:166:0;6472:421:13;8282:166:0;8459:28;8468:2;8472:7;8481:5;8459:8;:28::i;:::-;8153:341;8091:403;;:::o;9539:156::-;9660:28;9670:4;9676:2;9680:7;9660:9;:28::i;4116:841::-;4237:7;4276:16;4286:5;4276:9;:16::i;:::-;4268:5;:24;4260:71;;;;-1:-1:-1;;;4260:71:0;;7100:2:13;4260:71:0;;;7082:21:13;7139:2;7119:18;;;7112:30;7178:34;7158:18;;;7151:62;-1:-1:-1;;;7229:18:13;;;7222:32;7271:19;;4260:71:0;6898:398:13;4260:71:0;4341:22;3509:12;;;4341:22;;4470:415;4494:14;4490:1;:18;4470:415;;;4529:31;4563:14;;;:11;:14;;;;;;;;;4529:48;;;;;;;;;-1:-1:-1;;;;;4529:48:0;;;;;-1:-1:-1;;;4529:48:0;;;;;;;;;;;;4595:28;4591:101;;4663:14;;;-1:-1:-1;4591:101:0;4730:5;-1:-1:-1;;;;;4709:26:0;:17;-1:-1:-1;;;;;4709:26:0;;4705:170;;4774:5;4759:11;:20;4755:75;;-1:-1:-1;4810:1:0;-1:-1:-1;4803:8:0;;-1:-1:-1;;;4803:8:0;4755:75;4847:13;;;;:::i;:::-;;;;4705:170;-1:-1:-1;4510:3:0;;;;:::i;:::-;;;;4470:415;;;-1:-1:-1;4894:56:0;;-1:-1:-1;;;4894:56:0;;7775:2:13;4894:56:0;;;7757:21:13;7814:2;7794:18;;;7787:30;7853:34;7833:18;;;7826:62;-1:-1:-1;;;7904:18:13;;;7897:44;7958:19;;4894:56:0;7573:410:13;1131:303:1;1744:1:3;2325:7;;:19;2317:63;;;;-1:-1:-1;;;2317:63:3;;8190:2:13;2317:63:3;;;8172:21:13;8229:2;8209:18;;;8202:30;8268:33;8248:18;;;8241:61;8319:18;;2317:63:3;7988:355:13;2317:63:3;1744:1;2455:7;:18;1228:6:1::1;::::0;-1:-1:-1;;;;;1228:6:1::1;1214:10;:20;1206:43;;;::::0;-1:-1:-1;;;1206:43:1;;8550:2:13;1206:43:1::1;::::0;::::1;8532:21:13::0;8589:2;8569:18;;;8562:30;-1:-1:-1;;;8608:18:13;;;8601:40;8658:18;;1206:43:1::1;8348:334:13::0;1206:43:1::1;1259:14;3509:12:0::0;1321:14:1::1;1307:10;3509:12:0::0;1316:1:1::1;1307:10;:::i;:::-;:28;;1299:59;;;::::0;-1:-1:-1;;;1299:59:1;;9019:2:13;1299:59:1::1;::::0;::::1;9001:21:13::0;9058:2;9038:18;;;9031:30;-1:-1:-1;;;9077:18:13;;;9070:48;9135:18;;1299:59:1::1;8817:342:13::0;1299:59:1::1;1368:23;::::0;;;:15:::1;:23;::::0;;;;:33;;;1411:16:::1;1421:2:::0;1425:1:::1;1411:9;:16::i;:::-;-1:-1:-1::0;;1701:1:3;2628:7;:22;-1:-1:-1;1131:303:1:o;9761:171:0:-;9886:39;9903:4;9909:2;9913:7;9886:39;;;;;;;;;;;;:16;:39::i;3600:220::-;3699:7;3509:12;;3730:5;:21;3722:69;;;;-1:-1:-1;;;3722:69:0;;9366:2:13;3722:69:0;;;9348:21:13;9405:2;9385:18;;;9378:30;9444:34;9424:18;;;9417:62;-1:-1:-1;;;9495:18:13;;;9488:33;9538:19;;3722:69:0;9164:399:13;3722:69:0;-1:-1:-1;3808:5:0;3600:220::o;1777:96:1:-;1108:6:2;;-1:-1:-1;;;;;1108:6:2;719:10:9;1248:23:2;1240:68;;;;-1:-1:-1;;;1240:68:2;;;;;;;:::i;:::-;1850:7:1::1;:16;1860:6:::0;;1850:7;:16:::1;:::i;6736:122:0:-:0;6800:7;6826:20;6838:7;6826:11;:20::i;:::-;:25;;6736:122;-1:-1:-1;;6736:122:0:o;416:21:1:-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;924:103::-;1108:6:2;;-1:-1:-1;;;;;1108:6:2;719:10:9;1248:23:2;1240:68;;;;-1:-1:-1;;;1240:68:2;;;;;;;:::i;:::-;924:103:1;:::o;5493:252:0:-;5557:7;-1:-1:-1;;;;;5597:19:0;;5576:109;;;;-1:-1:-1;;;5576:109:0;;12189:2:13;5576:109:0;;;12171:21:13;12228:2;12208:18;;;12201:30;12267:34;12247:18;;;12240:62;-1:-1:-1;;;12318:18:13;;;12311:41;12369:19;;5576:109:0;11987:407:13;5576:109:0;-1:-1:-1;;;;;;5710:19:0;;;;;:12;:19;;;;;:27;-1:-1:-1;;;;;5710:27:0;;5493:252::o;1668:101:2:-;1108:6;;-1:-1:-1;;;;;1108:6:2;719:10:9;1248:23:2;1240:68;;;;-1:-1:-1;;;1240:68:2;;;;;;;:::i;:::-;1732:30:::1;1759:1;1732:18;:30::i;:::-;1668:101::o:0;7082:102:0:-;7138:13;7170:7;7163:14;;;;;:::i;8902:303::-;719:10:9;-1:-1:-1;;;;;9016:24:0;;;9008:63;;;;-1:-1:-1;;;9008:63:0;;12601:2:13;9008:63:0;;;12583:21:13;12640:2;12620:18;;;12613:30;12679:28;12659:18;;;12652:56;12725:18;;9008:63:0;12399:350:13;9008:63:0;719:10:9;9082:32:0;;;;:18;:32;;;;;;;;-1:-1:-1;;;;;9082:42:0;;;;;;;;;;;;:53;;-1:-1:-1;;9082:53:0;;;;;;;;;;9150:48;;540:41:13;;;9082:42:0;;719:10:9;9150:48:0;;513:18:13;9150:48:0;;;;;;;8902:303;;:::o;9998:344::-;10151:28;10161:4;10167:2;10171:7;10151:9;:28::i;:::-;10210:48;10233:4;10239:2;10243:7;10252:5;10210:22;:48::i;:::-;10189:146;;;;-1:-1:-1;;;10189:146:0;;;;;;;:::i;:::-;9998:344;;;;:::o;1440:331:1:-;1553:13;1618:1;1590:16;1598:7;1590;:16::i;:::-;-1:-1:-1;;;;;1590:30:1;;1582:60;;;;-1:-1:-1;;;1582:60:1;;13376:2:13;1582:60:1;;;13358:21:13;13415:2;13395:18;;;13388:30;-1:-1:-1;;;13434:18:13;;;13427:47;13491:18;;1582:60:1;13174:341:13;1582:60:1;1652:28;1683:10;:8;:10::i;:::-;1652:41;;1741:1;1716:14;1710:28;:32;:54;;;;;;;;;;;;;;;;;1745:14;1710:54;1703:61;1440:331;-1:-1:-1;;;1440:331:1:o;1918:198:2:-;1108:6;;-1:-1:-1;;;;;1108:6:2;719:10:9;1248:23:2;1240:68;;;;-1:-1:-1;;;1240:68:2;;;;;;;:::i;:::-;-1:-1:-1;;;;;2006:22:2;::::1;1998:73;;;::::0;-1:-1:-1;;;1998:73:2;;13722:2:13;1998:73:2::1;::::0;::::1;13704:21:13::0;13761:2;13741:18;;;13734:30;13800:34;13780:18;;;13773:62;-1:-1:-1;;;13851:18:13;;;13844:36;13897:19;;1998:73:2::1;13520:402:13::0;1998:73:2::1;2081:28;2100:8;2081:18;:28::i;828:90:1:-:0;1108:6:2;;-1:-1:-1;;;;;1108:6:2;719:10:9;1248:23:2;1240:68;;;;-1:-1:-1;;;1240:68:2;;;;;;;:::i;:::-;893:6:1::1;:18:::0;;-1:-1:-1;;;;;;893:18:1::1;-1:-1:-1::0;;;;;893:18:1;;;::::1;::::0;;;::::1;::::0;;828:90::o;14539:189:0:-;14649:24;;;;:15;:24;;;;;;:29;;-1:-1:-1;;;;;;14649:29:0;-1:-1:-1;;;;;14649:29:0;;;;;;;;;14693:28;;14649:24;;14693:28;;;;;;;14539:189;;;:::o;12764:1664::-;12874:35;12912:20;12924:7;12912:11;:20::i;:::-;12985:18;;12874:58;;-1:-1:-1;12943:22:0;;-1:-1:-1;;;;;12969:34:0;719:10:9;-1:-1:-1;;;;;12969:34:0;;:86;;;-1:-1:-1;719:10:9;13019:20:0;13031:7;13019:11;:20::i;:::-;-1:-1:-1;;;;;13019:36:0;;12969:86;:152;;;-1:-1:-1;13088:18:0;;13071:50;;719:10:9;9271:206:0;:::i;13071:50::-;12943:179;;13154:17;13133:114;;;;-1:-1:-1;;;13133:114:0;;14129:2:13;13133:114:0;;;14111:21:13;14168:2;14148:18;;;14141:30;14207:34;14187:18;;;14180:62;-1:-1:-1;;;14258:18:13;;;14251:48;14316:19;;13133:114:0;13927:414:13;13133:114:0;13301:4;-1:-1:-1;;;;;13279:26:0;:13;:18;;;-1:-1:-1;;;;;13279:26:0;;13258:111;;;;-1:-1:-1;;;13258:111:0;;14548:2:13;13258:111:0;;;14530:21:13;14587:2;14567:18;;;14560:30;14626:34;14606:18;;;14599:62;-1:-1:-1;;;14677:18:13;;;14670:36;14723:19;;13258:111:0;14346:402:13;13258:111:0;-1:-1:-1;;;;;13387:16:0;;13379:66;;;;-1:-1:-1;;;13379:66:0;;14955:2:13;13379:66:0;;;14937:21:13;14994:2;14974:18;;;14967:30;15033:34;15013:18;;;15006:62;-1:-1:-1;;;15084:18:13;;;15077:35;15129:19;;13379:66:0;14753:401:13;13379:66:0;13561:49;13578:1;13582:7;13591:13;:18;;;13561:8;:49::i;:::-;-1:-1:-1;;;;;13621:18:0;;;;;;:12;:18;;;;;:31;;13651:1;;13621:18;:31;;13651:1;;-1:-1:-1;;;;;13621:31:0;;:::i;:::-;;;;;;;;-1:-1:-1;;;;;13621:31:0;;;;;;;;;;;;;;;-1:-1:-1;;;;;13662:16:0;;-1:-1:-1;13662:16:0;;;:12;:16;;;;;:29;;-1:-1:-1;;;13662:16:0;;:29;;-1:-1:-1;;13662:29:0;;:::i;:::-;;;-1:-1:-1;;;;;13662:29:0;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;13724:43:0;;;;;;;;-1:-1:-1;;;;;13724:43:0;;;;;;13750:15;13724:43;;;;;;;;;-1:-1:-1;13701:20:0;;;:11;:20;;;;;;:66;;;;;;;;;-1:-1:-1;;;13701:66:0;-1:-1:-1;;;;;;13701:66:0;;;;;;;;;;;14025:11;13713:7;-1:-1:-1;14025:11:0;:::i;:::-;14091:1;14050:24;;;:11;:24;;;;;:29;14003:33;;-1:-1:-1;;;;;;14050:29:0;14046:281;;14113:20;14121:11;10645:4;10678:12;-1:-1:-1;10668:22:0;10588:109;14113:20;14109:208;;;14180:122;;;;;;;;14216:18;;-1:-1:-1;;;;;14180:122:0;;;;;;14256:28;;;;14180:122;;;;;;;;;;-1:-1:-1;14153:24:0;;;:11;:24;;;;;;;:149;;;;;;;;;-1:-1:-1;;;14153:149:0;-1:-1:-1;;;;;;14153:149:0;;;;;;;;;;;;14109:208;14361:7;14357:2;-1:-1:-1;;;;;14342:27:0;14351:4;-1:-1:-1;;;;;14342:27:0;;;;;;;;;;;14379:42;12864:1564;;;12764:1664;;;:::o;10703:102::-;10771:27;10781:2;10785:8;10771:27;;;;;;;;;;;;:9;:27::i;:::-;10703:102;;:::o;6017:662::-;-1:-1:-1;;;;;;;;;;;;;;;;;6147:16:0;6155:7;10645:4;10678:12;-1:-1:-1;10668:22:0;10588:109;6147:16;6139:71;;;;-1:-1:-1;;;6139:71:0;;15768:2:13;6139:71:0;;;15750:21:13;15807:2;15787:18;;;15780:30;15846:34;15826:18;;;15819:62;-1:-1:-1;;;15897:18:13;;;15890:40;15947:19;;6139:71:0;15566:406:13;6139:71:0;6221:26;6272:12;6261:7;:23;6257:101;;6321:22;6331:12;6321:7;:22;:::i;:::-;:26;;6346:1;6321:26;:::i;:::-;6300:47;;6257:101;6388:7;6368:237;6405:18;6397:4;:26;6368:237;;6447:31;6481:17;;;:11;:17;;;;;;;;;6447:51;;;;;;;;;-1:-1:-1;;;;;6447:51:0;;;;;-1:-1:-1;;;6447:51:0;;;;;;;;;;;;6516:28;6512:83;;6571:9;6017:662;-1:-1:-1;;;;6017:662:0:o;6512:83::-;-1:-1:-1;6425:6:0;;;;:::i;:::-;;;;6368:237;;;-1:-1:-1;6615:57:0;;-1:-1:-1;;;6615:57:0;;16453:2:13;6615:57:0;;;16435:21:13;16492:2;16472:18;;;16465:30;16531:34;16511:18;;;16504:62;-1:-1:-1;;;16582:18:13;;;16575:45;16637:19;;6615:57:0;16251:411:13;2270:187:2;2362:6;;;-1:-1:-1;;;;;2378:17:2;;;-1:-1:-1;;;;;;2378:17:2;;;;;;;2410:40;;2362:6;;;2378:17;2362:6;;2410:40;;2343:16;;2410:40;2333:124;2270:187;:::o;16369:955:0:-;16519:4;-1:-1:-1;;;;;16539:13:0;;1465:19:8;:23;16535:783:0;;16590:170;;-1:-1:-1;;;16590:170:0;;-1:-1:-1;;;;;16590:36:0;;;;;:170;;719:10:9;;16682:4:0;;16708:7;;16737:5;;16590:170;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;-1:-1:-1;16590:170:0;;;;;;;;-1:-1:-1;;16590:170:0;;;;;;;;;;;;:::i;:::-;;;16570:696;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;16943:6;:13;16960:1;16943:18;16939:313;;16985:107;;-1:-1:-1;;;16985:107:0;;;;;;;:::i;16939:313::-;17204:6;17198:13;17189:6;17185:2;17181:15;17174:38;16570:696;-1:-1:-1;;;;;;16822:55:0;-1:-1:-1;;;16822:55:0;;-1:-1:-1;16815:62:0;;16535:783;-1:-1:-1;17303:4:0;16535:783;16369:955;;;;;;:::o;1879:106:1:-;1939:13;1971:7;1964:14;;;;;:::i;11155:1367:0:-;11273:20;11296:12;-1:-1:-1;;;;;11326:16:0;;11318:62;;;;-1:-1:-1;;;11318:62:0;;17617:2:13;11318:62:0;;;17599:21:13;17656:2;17636:18;;;17629:30;17695:34;17675:18;;;17668:62;-1:-1:-1;;;17746:18:13;;;17739:31;17787:19;;11318:62:0;17415:397:13;11318:62:0;11523:21;11531:12;10645:4;10678:12;-1:-1:-1;10668:22:0;10588:109;11523:21;11522:22;11514:64;;;;-1:-1:-1;;;11514:64:0;;18019:2:13;11514:64:0;;;18001:21:13;18058:2;18038:18;;;18031:30;18097:31;18077:18;;;18070:59;18146:18;;11514:64:0;17817:353:13;11514:64:0;11608:12;11596:8;:24;;11588:71;;;;-1:-1:-1;;;11588:71:0;;18377:2:13;11588:71:0;;;18359:21:13;18416:2;18396:18;;;18389:30;18455:34;18435:18;;;18428:62;-1:-1:-1;;;18506:18:13;;;18499:32;18548:19;;11588:71:0;18175:398:13;11588:71:0;-1:-1:-1;;;;;11775:16:0;;11742:30;11775:16;;;:12;:16;;;;;;;;;11742:49;;;;;;;;;-1:-1:-1;;;;;11742:49:0;;;;;-1:-1:-1;;;11742:49:0;;;;;;;;;;;11820:132;;;;;;;;11845:19;;11742:49;;11820:132;;;11845:39;;11875:8;;11845:39;:::i;:::-;-1:-1:-1;;;;;11820:132:0;;;;;11933:8;11898:11;:24;;;:44;;;;:::i;:::-;-1:-1:-1;;;;;11820:132:0;;;;;;-1:-1:-1;;;;;11801:16:0;;;;;;;:12;:16;;;;;;;;:151;;;;;;;;-1:-1:-1;;;11801:151:0;;;;;;;;;;;;11990:43;;;;;;;;;;;12016:15;11990:43;;;;;;;;11962:25;;;:11;:25;;;;;;:71;;;;;;;;;-1:-1:-1;;;11962:71:0;-1:-1:-1;;;;;;11962:71:0;;;;;;;;;;;;;;;;;;11974:12;;12090:318;12114:8;12110:1;:12;12090:318;;;12148:38;;12173:12;;-1:-1:-1;;;;;12148:38:0;;;12165:1;;12148:38;;12165:1;;12148:38;12225:59;12256:1;12260:2;12264:12;12278:5;12225:22;:59::i;:::-;12200:169;;;;-1:-1:-1;;;12200:169:0;;;;;;;:::i;:::-;12383:14;;;;:::i;:::-;;;;12124:3;;;;;:::i;:::-;;;;12090:318;;;-1:-1:-1;12418:12:0;:27;;;12455:60;9998:344;14:131:13;-1:-1:-1;;;;;;88:32:13;;78:43;;68:71;;135:1;132;125:12;150:245;208:6;261:2;249:9;240:7;236:23;232:32;229:52;;;277:1;274;267:12;229:52;316:9;303:23;335:30;359:5;335:30;:::i;592:423::-;634:3;672:5;666:12;699:6;694:3;687:19;724:1;734:162;748:6;745:1;742:13;734:162;;;810:4;866:13;;;862:22;;856:29;838:11;;;834:20;;827:59;763:12;734:162;;;738:3;941:1;934:4;925:6;920:3;916:16;912:27;905:38;1004:4;997:2;993:7;988:2;980:6;976:15;972:29;967:3;963:39;959:50;952:57;;;592:423;;;;:::o;1020:220::-;1169:2;1158:9;1151:21;1132:4;1189:45;1230:2;1219:9;1215:18;1207:6;1189:45;:::i;1453:180::-;1512:6;1565:2;1553:9;1544:7;1540:23;1536:32;1533:52;;;1581:1;1578;1571:12;1533:52;-1:-1:-1;1604:23:13;;1453:180;-1:-1:-1;1453:180:13:o;1638:173::-;1706:20;;-1:-1:-1;;;;;1755:31:13;;1745:42;;1735:70;;1801:1;1798;1791:12;1735:70;1638:173;;;:::o;1816:254::-;1884:6;1892;1945:2;1933:9;1924:7;1920:23;1916:32;1913:52;;;1961:1;1958;1951:12;1913:52;1984:29;2003:9;1984:29;:::i;:::-;1974:39;2060:2;2045:18;;;;2032:32;;-1:-1:-1;;;1816:254:13:o;2257:328::-;2334:6;2342;2350;2403:2;2391:9;2382:7;2378:23;2374:32;2371:52;;;2419:1;2416;2409:12;2371:52;2442:29;2461:9;2442:29;:::i;:::-;2432:39;;2490:38;2524:2;2513:9;2509:18;2490:38;:::i;:::-;2480:48;;2575:2;2564:9;2560:18;2547:32;2537:42;;2257:328;;;;;:::o;2590:592::-;2661:6;2669;2722:2;2710:9;2701:7;2697:23;2693:32;2690:52;;;2738:1;2735;2728:12;2690:52;2778:9;2765:23;2807:18;2848:2;2840:6;2837:14;2834:34;;;2864:1;2861;2854:12;2834:34;2902:6;2891:9;2887:22;2877:32;;2947:7;2940:4;2936:2;2932:13;2928:27;2918:55;;2969:1;2966;2959:12;2918:55;3009:2;2996:16;3035:2;3027:6;3024:14;3021:34;;;3051:1;3048;3041:12;3021:34;3096:7;3091:2;3082:6;3078:2;3074:15;3070:24;3067:37;3064:57;;;3117:1;3114;3107:12;3064:57;3148:2;3140:11;;;;;3170:6;;-1:-1:-1;2590:592:13;;-1:-1:-1;;;;2590:592:13:o;3187:186::-;3246:6;3299:2;3287:9;3278:7;3274:23;3270:32;3267:52;;;3315:1;3312;3305:12;3267:52;3338:29;3357:9;3338:29;:::i;3378:347::-;3443:6;3451;3504:2;3492:9;3483:7;3479:23;3475:32;3472:52;;;3520:1;3517;3510:12;3472:52;3543:29;3562:9;3543:29;:::i;:::-;3533:39;;3622:2;3611:9;3607:18;3594:32;3669:5;3662:13;3655:21;3648:5;3645:32;3635:60;;3691:1;3688;3681:12;3635:60;3714:5;3704:15;;;3378:347;;;;;:::o;3730:127::-;3791:10;3786:3;3782:20;3779:1;3772:31;3822:4;3819:1;3812:15;3846:4;3843:1;3836:15;3862:1138;3957:6;3965;3973;3981;4034:3;4022:9;4013:7;4009:23;4005:33;4002:53;;;4051:1;4048;4041:12;4002:53;4074:29;4093:9;4074:29;:::i;:::-;4064:39;;4122:38;4156:2;4145:9;4141:18;4122:38;:::i;:::-;4112:48;;4207:2;4196:9;4192:18;4179:32;4169:42;;4262:2;4251:9;4247:18;4234:32;4285:18;4326:2;4318:6;4315:14;4312:34;;;4342:1;4339;4332:12;4312:34;4380:6;4369:9;4365:22;4355:32;;4425:7;4418:4;4414:2;4410:13;4406:27;4396:55;;4447:1;4444;4437:12;4396:55;4483:2;4470:16;4505:2;4501;4498:10;4495:36;;;4511:18;;:::i;:::-;4586:2;4580:9;4554:2;4640:13;;-1:-1:-1;;4636:22:13;;;4660:2;4632:31;4628:40;4616:53;;;4684:18;;;4704:22;;;4681:46;4678:72;;;4730:18;;:::i;:::-;4770:10;4766:2;4759:22;4805:2;4797:6;4790:18;4845:7;4840:2;4835;4831;4827:11;4823:20;4820:33;4817:53;;;4866:1;4863;4856:12;4817:53;4922:2;4917;4913;4909:11;4904:2;4896:6;4892:15;4879:46;4967:1;4962:2;4957;4949:6;4945:15;4941:24;4934:35;4988:6;4978:16;;;;;;;3862:1138;;;;;;;:::o;5005:260::-;5073:6;5081;5134:2;5122:9;5113:7;5109:23;5105:32;5102:52;;;5150:1;5147;5140:12;5102:52;5173:29;5192:9;5173:29;:::i;:::-;5163:39;;5221:38;5255:2;5244:9;5240:18;5221:38;:::i;:::-;5211:48;;5005:260;;;;;:::o;5270:380::-;5349:1;5345:12;;;;5392;;;5413:61;;5467:4;5459:6;5455:17;5445:27;;5413:61;5520:2;5512:6;5509:14;5489:18;5486:38;5483:161;;5566:10;5561:3;5557:20;5554:1;5547:31;5601:4;5598:1;5591:15;5629:4;5626:1;5619:15;5483:161;;5270:380;;;:::o;7301:127::-;7362:10;7357:3;7353:20;7350:1;7343:31;7393:4;7390:1;7383:15;7417:4;7414:1;7407:15;7433:135;7472:3;7493:17;;;7490:43;;7513:18;;:::i;:::-;-1:-1:-1;7560:1:13;7549:13;;7433:135::o;8687:125::-;8752:9;;;8773:10;;;8770:36;;;8786:18;;:::i;9568:356::-;9770:2;9752:21;;;9789:18;;;9782:30;9848:34;9843:2;9828:18;;9821:62;9915:2;9900:18;;9568:356::o;10055:545::-;10157:2;10152:3;10149:11;10146:448;;;10193:1;10218:5;10214:2;10207:17;10263:4;10259:2;10249:19;10333:2;10321:10;10317:19;10314:1;10310:27;10304:4;10300:38;10369:4;10357:10;10354:20;10351:47;;;-1:-1:-1;10392:4:13;10351:47;10447:2;10442:3;10438:12;10435:1;10431:20;10425:4;10421:31;10411:41;;10502:82;10520:2;10513:5;10510:13;10502:82;;;10565:17;;;10546:1;10535:13;10502:82;;10776:1206;10900:18;10895:3;10892:27;10889:53;;;10922:18;;:::i;:::-;10951:94;11041:3;11001:38;11033:4;11027:11;11001:38;:::i;:::-;10995:4;10951:94;:::i;:::-;11071:1;11096:2;11091:3;11088:11;11113:1;11108:616;;;;11768:1;11785:3;11782:93;;;-1:-1:-1;11841:19:13;;;11828:33;11782:93;-1:-1:-1;;10733:1:13;10729:11;;;10725:24;10721:29;10711:40;10757:1;10753:11;;;10708:57;11888:78;;11081:895;;11108:616;10002:1;9995:14;;;10039:4;10026:18;;-1:-1:-1;;11144:17:13;;;11245:9;11267:229;11281:7;11278:1;11275:14;11267:229;;;11370:19;;;11357:33;11342:49;;11477:4;11462:20;;;;11430:1;11418:14;;;;11297:12;11267:229;;;11271:3;11524;11515:7;11512:16;11509:159;;;11648:1;11644:6;11638:3;11632;11629:1;11625:11;11621:21;11617:34;11613:39;11600:9;11595:3;11591:19;11578:33;11574:79;11566:6;11559:95;11509:159;;;11711:1;11705:3;11702:1;11698:11;11694:19;11688:4;11681:33;11081:895;;;10776:1206;;;:::o;12754:415::-;12956:2;12938:21;;;12995:2;12975:18;;;12968:30;13034:34;13029:2;13014:18;;13007:62;-1:-1:-1;;;13100:2:13;13085:18;;13078:49;13159:3;13144:19;;12754:415::o;15159:200::-;-1:-1:-1;;;;;15295:10:13;;;15283;;;15279:27;;15318:12;;;15315:38;;;15333:18;;:::i;:::-;15315:38;15159:200;;;;:::o;15364:197::-;-1:-1:-1;;;;;15486:10:13;;;15498;;;15482:27;;15521:11;;;15518:37;;;15535:18;;:::i;15977:128::-;16044:9;;;16065:11;;;16062:37;;;16079:18;;:::i;16110:136::-;16149:3;16177:5;16167:39;;16186:18;;:::i;:::-;-1:-1:-1;;;16222:18:13;;16110:136::o;16667:489::-;-1:-1:-1;;;;;16936:15:13;;;16918:34;;16988:15;;16983:2;16968:18;;16961:43;17035:2;17020:18;;17013:34;;;17083:3;17078:2;17063:18;;17056:31;;;16861:4;;17104:46;;17130:19;;17122:6;17104:46;:::i;:::-;17096:54;16667:489;-1:-1:-1;;;;;;16667:489:13:o;17161:249::-;17230:6;17283:2;17271:9;17262:7;17258:23;17254:32;17251:52;;;17299:1;17296;17289:12;17251:52;17331:9;17325:16;17350:30;17374:5;17350:30;:::i",
  sourcePath:
    "/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/contracts/ZoofrenzFirstClassPass/ZoofrenzFirstClassPass.sol",
  compiler: {
    name: "solc",
    version: "0.8.16+commit.07a7930e",
  },
  ast: {
    absolutePath:
      "/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/contracts/ZoofrenzFirstClassPass/ZoofrenzFirstClassPass.sol",
    exportedSymbols: {
      Address: [1995],
      Context: [2017],
      ERC165: [2244],
      ERC721A: [1194],
      IERC165: [2256],
      IERC721: [1624],
      IERC721Enumerable: [1673],
      IERC721Metadata: [1700],
      IERC721Receiver: [1642],
      Ownable: [1468],
      ReentrancyGuard: [1508],
      Strings: [2220],
      ZoofrenzFirstClassPass: [1363],
    },
    id: 1364,
    license: "MIT",
    nodeType: "SourceUnit",
    nodes: [
      {
        id: 1196,
        literals: ["solidity", "^", "0.8", ".0"],
        nodeType: "PragmaDirective",
        src: "32:23:1",
      },
      {
        absolutePath:
          "/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/access/Ownable.sol",
        file: "/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/access/Ownable.sol",
        id: 1197,
        nameLocation: "-1:-1:-1",
        nodeType: "ImportDirective",
        scope: 1364,
        sourceUnit: 1469,
        src: "56:122:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath:
          "/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/security/ReentrancyGuard.sol",
        file: "/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/node_modules/@openzeppelin/contracts/security/ReentrancyGuard.sol",
        id: 1198,
        nameLocation: "-1:-1:-1",
        nodeType: "ImportDirective",
        scope: 1364,
        sourceUnit: 1509,
        src: "179:132:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath:
          "/Volumes/Work/github.com/zombotstudio/zoofrenz-contracts/contracts/ZoofrenzFirstClassPass/ERC721A_old.sol",
        file: "./ERC721A_old.sol",
        id: 1199,
        nameLocation: "-1:-1:-1",
        nodeType: "ImportDirective",
        scope: 1364,
        sourceUnit: 1195,
        src: "312:27:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 1200,
              name: "ERC721A",
              nameLocations: ["376:7:1"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 1194,
              src: "376:7:1",
            },
            id: 1201,
            nodeType: "InheritanceSpecifier",
            src: "376:7:1",
          },
          {
            baseName: {
              id: 1202,
              name: "Ownable",
              nameLocations: ["385:7:1"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 1468,
              src: "385:7:1",
            },
            id: 1203,
            nodeType: "InheritanceSpecifier",
            src: "385:7:1",
          },
          {
            baseName: {
              id: 1204,
              name: "ReentrancyGuard",
              nameLocations: ["394:15:1"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 1508,
              src: "394:15:1",
            },
            id: 1205,
            nodeType: "InheritanceSpecifier",
            src: "394:15:1",
          },
        ],
        canonicalName: "ZoofrenzFirstClassPass",
        contractDependencies: [],
        contractKind: "contract",
        fullyImplemented: true,
        id: 1363,
        linearizedBaseContracts: [
          1363, 1508, 1468, 1194, 1673, 1700, 1624, 2244, 2256, 2017,
        ],
        name: "ZoofrenzFirstClassPass",
        nameLocation: "350:22:1",
        nodeType: "ContractDefinition",
        nodes: [
          {
            constant: false,
            functionSelector: "6c0360eb",
            id: 1207,
            mutability: "mutable",
            name: "baseURI",
            nameLocation: "430:7:1",
            nodeType: "VariableDeclaration",
            scope: 1363,
            src: "416:21:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_string_storage",
              typeString: "string",
            },
            typeName: {
              id: 1206,
              name: "string",
              nodeType: "ElementaryTypeName",
              src: "416:6:1",
              typeDescriptions: {
                typeIdentifier: "t_string_storage_ptr",
                typeString: "string",
              },
            },
            visibility: "public",
          },
          {
            constant: false,
            functionSelector: "07546172",
            id: 1209,
            mutability: "mutable",
            name: "minter",
            nameLocation: "458:6:1",
            nodeType: "VariableDeclaration",
            scope: 1363,
            src: "443:21:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_address",
              typeString: "address",
            },
            typeName: {
              id: 1208,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "443:7:1",
              stateMutability: "nonpayable",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address",
              },
            },
            visibility: "public",
          },
          {
            constant: false,
            functionSelector: "2a18624f",
            id: 1213,
            mutability: "mutable",
            name: "originalTokenId",
            nameLocation: "505:15:1",
            nodeType: "VariableDeclaration",
            scope: 1363,
            src: "470:50:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
              typeString: "mapping(uint256 => uint256)",
            },
            typeName: {
              id: 1212,
              keyType: {
                id: 1210,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "478:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
              },
              nodeType: "Mapping",
              src: "470:27:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                typeString: "mapping(uint256 => uint256)",
              },
              valueType: {
                id: 1211,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "489:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
              },
            },
            visibility: "public",
          },
          {
            body: {
              id: 1232,
              nodeType: "Block",
              src: "786:36:1",
              statements: [
                {
                  expression: {
                    id: 1230,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 1228,
                      name: "minter",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1209,
                      src: "796:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 1229,
                      name: "initMinter",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1215,
                      src: "805:10:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address",
                      },
                    },
                    src: "796:19:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  id: 1231,
                  nodeType: "ExpressionStatement",
                  src: "796:19:1",
                },
              ],
            },
            id: 1233,
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    hexValue:
                      "5a6f6f6672656e7a20466972737420436c6173732050617373",
                    id: 1222,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "string",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "667:27:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_stringliteral_c09489389156d89daaae88a0920bc369f699919ace217d8b9d6d9be1b1113500",
                      typeString: 'literal_string "Zoofrenz First Class Pass"',
                    },
                    value: "Zoofrenz First Class Pass",
                  },
                  {
                    hexValue: "5a564950",
                    id: 1223,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "string",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "708:6:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_stringliteral_c567b07b9d7529ae6147e4f41dc8e6189eb12415f5db52bfe13521d4410bbdcd",
                      typeString: 'literal_string "ZVIP"',
                    },
                    value: "ZVIP",
                  },
                  {
                    id: 1224,
                    name: "maxAmountPerMint",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 1217,
                    src: "728:16:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  {
                    id: 1225,
                    name: "maxCollection",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 1219,
                    src: "758:13:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                ],
                id: 1226,
                kind: "baseConstructorSpecifier",
                modifierName: {
                  id: 1221,
                  name: "ERC721A",
                  nameLocations: ["646:7:1"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 1194,
                  src: "646:7:1",
                },
                nodeType: "ModifierInvocation",
                src: "646:135:1",
              },
            ],
            name: "",
            nameLocation: "-1:-1:-1",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 1220,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1215,
                  mutability: "mutable",
                  name: "initMinter",
                  nameLocation: "556:10:1",
                  nodeType: "VariableDeclaration",
                  scope: 1233,
                  src: "548:18:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 1214,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "548:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 1217,
                  mutability: "mutable",
                  name: "maxAmountPerMint",
                  nameLocation: "584:16:1",
                  nodeType: "VariableDeclaration",
                  scope: 1233,
                  src: "576:24:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 1216,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "576:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 1219,
                  mutability: "mutable",
                  name: "maxCollection",
                  nameLocation: "618:13:1",
                  nodeType: "VariableDeclaration",
                  scope: 1233,
                  src: "610:21:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 1218,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "610:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "538:99:1",
            },
            returnParameters: {
              id: 1227,
              nodeType: "ParameterList",
              parameters: [],
              src: "786:0:1",
            },
            scope: 1363,
            src: "527:295:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public",
          },
          {
            body: {
              id: 1244,
              nodeType: "Block",
              src: "883:35:1",
              statements: [
                {
                  expression: {
                    id: 1242,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 1240,
                      name: "minter",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1209,
                      src: "893:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 1241,
                      name: "newMinter",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1235,
                      src: "902:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address",
                      },
                    },
                    src: "893:18:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  id: 1243,
                  nodeType: "ExpressionStatement",
                  src: "893:18:1",
                },
              ],
            },
            functionSelector: "fca3b5aa",
            id: 1245,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 1238,
                kind: "modifierInvocation",
                modifierName: {
                  id: 1237,
                  name: "onlyOwner",
                  nameLocations: ["873:9:1"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 1410,
                  src: "873:9:1",
                },
                nodeType: "ModifierInvocation",
                src: "873:9:1",
              },
            ],
            name: "setMinter",
            nameLocation: "837:9:1",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 1236,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1235,
                  mutability: "mutable",
                  name: "newMinter",
                  nameLocation: "855:9:1",
                  nodeType: "VariableDeclaration",
                  scope: 1245,
                  src: "847:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 1234,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "847:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "846:19:1",
            },
            returnParameters: {
              id: 1239,
              nodeType: "ParameterList",
              parameters: [],
              src: "883:0:1",
            },
            scope: 1363,
            src: "828:90:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public",
          },
          {
            body: {
              id: 1252,
              nodeType: "Block",
              src: "982:45:1",
              statements: [],
            },
            functionSelector: "6f8b44b0",
            id: 1253,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 1250,
                kind: "modifierInvocation",
                modifierName: {
                  id: 1249,
                  name: "onlyOwner",
                  nameLocations: ["972:9:1"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 1410,
                  src: "972:9:1",
                },
                nodeType: "ModifierInvocation",
                src: "972:9:1",
              },
            ],
            name: "setMaxSupply",
            nameLocation: "933:12:1",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 1248,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1247,
                  mutability: "mutable",
                  name: "newSupply",
                  nameLocation: "954:9:1",
                  nodeType: "VariableDeclaration",
                  scope: 1253,
                  src: "946:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 1246,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "946:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "945:19:1",
            },
            returnParameters: {
              id: 1251,
              nodeType: "ParameterList",
              parameters: [],
              src: "982:0:1",
            },
            scope: 1363,
            src: "924:103:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public",
          },
          {
            body: {
              id: 1260,
              nodeType: "Block",
              src: "1087:38:1",
              statements: [
                {
                  expression: {
                    id: 1258,
                    name: "collectionSize",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 41,
                    src: "1104:14:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  functionReturnParameters: 1257,
                  id: 1259,
                  nodeType: "Return",
                  src: "1097:21:1",
                },
              ],
            },
            functionSelector: "4c0f38c2",
            id: 1261,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getMaxSupply",
            nameLocation: "1042:12:1",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 1254,
              nodeType: "ParameterList",
              parameters: [],
              src: "1054:2:1",
            },
            returnParameters: {
              id: 1257,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1256,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 1261,
                  src: "1078:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 1255,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1078:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1077:9:1",
            },
            scope: 1363,
            src: "1033:92:1",
            stateMutability: "view",
            virtual: false,
            visibility: "public",
          },
          {
            body: {
              id: 1303,
              nodeType: "Block",
              src: "1196:238:1",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                        id: 1274,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            id: 1271,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 4294967281,
                            src: "1214:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg",
                            },
                          },
                          id: 1272,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "1218:6:1",
                          memberName: "sender",
                          nodeType: "MemberAccess",
                          src: "1214:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          id: 1273,
                          name: "minter",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 1209,
                          src: "1228:6:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        src: "1214:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        hexValue: "6e6f74206d696e746572",
                        id: 1275,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1236:12:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_c3f2065c7ea3b20d89603c4967e2aefee454763c2143e29a0c585ad871c002a0",
                          typeString: 'literal_string "not minter"',
                        },
                        value: "not minter",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_c3f2065c7ea3b20d89603c4967e2aefee454763c2143e29a0c585ad871c002a0",
                          typeString: 'literal_string "not minter"',
                        },
                      ],
                      id: 1270,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [4294967278, 4294967278],
                      referencedDeclaration: 4294967278,
                      src: "1206:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 1276,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1206:43:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 1277,
                  nodeType: "ExpressionStatement",
                  src: "1206:43:1",
                },
                {
                  assignments: [1279],
                  declarations: [
                    {
                      constant: false,
                      id: 1279,
                      mutability: "mutable",
                      name: "supply",
                      nameLocation: "1267:6:1",
                      nodeType: "VariableDeclaration",
                      scope: 1303,
                      src: "1259:14:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 1278,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "1259:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 1282,
                  initialValue: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 1280,
                      name: "totalSupply",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 120,
                      src: "1276:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_internal_view$__$returns$_t_uint256_$",
                        typeString: "function () view returns (uint256)",
                      },
                    },
                    id: 1281,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1276:13:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1259:30:1",
                },
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 1288,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                          id: 1286,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            id: 1284,
                            name: "supply",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 1279,
                            src: "1307:6:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "BinaryOperation",
                          operator: "+",
                          rightExpression: {
                            hexValue: "31",
                            id: 1285,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "1316:1:1",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_1_by_1",
                              typeString: "int_const 1",
                            },
                            value: "1",
                          },
                          src: "1307:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: "<=",
                        rightExpression: {
                          id: 1287,
                          name: "collectionSize",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 41,
                          src: "1321:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        src: "1307:28:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        hexValue: "65786365656473206d617820737570706c79",
                        id: 1289,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1337:20:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_6bf8d4faa51cc30f22ecf8b331d3a6f011823df6bd55378c88250e2fa556a583",
                          typeString: 'literal_string "exceeds max supply"',
                        },
                        value: "exceeds max supply",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_6bf8d4faa51cc30f22ecf8b331d3a6f011823df6bd55378c88250e2fa556a583",
                          typeString: 'literal_string "exceeds max supply"',
                        },
                      ],
                      id: 1283,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [4294967278, 4294967278],
                      referencedDeclaration: 4294967278,
                      src: "1299:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 1290,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1299:59:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 1291,
                  nodeType: "ExpressionStatement",
                  src: "1299:59:1",
                },
                {
                  expression: {
                    id: 1296,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 1292,
                        name: "originalTokenId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 1213,
                        src: "1368:15:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                          typeString: "mapping(uint256 => uint256)",
                        },
                      },
                      id: 1294,
                      indexExpression: {
                        id: 1293,
                        name: "supply",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 1279,
                        src: "1384:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "1368:23:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 1295,
                      name: "tokenId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1265,
                      src: "1394:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1368:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  id: 1297,
                  nodeType: "ExpressionStatement",
                  src: "1368:33:1",
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 1299,
                        name: "to",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 1263,
                        src: "1421:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      {
                        hexValue: "31",
                        id: 1300,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1425:1:1",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1",
                        },
                        value: "1",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                        {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1",
                        },
                      ],
                      id: 1298,
                      name: "_safeMint",
                      nodeType: "Identifier",
                      overloadedDeclarations: [684, 830],
                      referencedDeclaration: 684,
                      src: "1411:9:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256)",
                      },
                    },
                    id: 1301,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1411:16:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 1302,
                  nodeType: "ExpressionStatement",
                  src: "1411:16:1",
                },
              ],
            },
            functionSelector: "40c10f19",
            id: 1304,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 1268,
                kind: "modifierInvocation",
                modifierName: {
                  id: 1267,
                  name: "nonReentrant",
                  nameLocations: ["1183:12:1"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 1507,
                  src: "1183:12:1",
                },
                nodeType: "ModifierInvocation",
                src: "1183:12:1",
              },
            ],
            name: "mint",
            nameLocation: "1140:4:1",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 1266,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1263,
                  mutability: "mutable",
                  name: "to",
                  nameLocation: "1153:2:1",
                  nodeType: "VariableDeclaration",
                  scope: 1304,
                  src: "1145:10:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 1262,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1145:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 1265,
                  mutability: "mutable",
                  name: "tokenId",
                  nameLocation: "1165:7:1",
                  nodeType: "VariableDeclaration",
                  scope: 1304,
                  src: "1157:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 1264,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1157:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1144:29:1",
            },
            returnParameters: {
              id: 1269,
              nodeType: "ParameterList",
              parameters: [],
              src: "1196:0:1",
            },
            scope: 1363,
            src: "1131:303:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            baseFunctions: [464],
            body: {
              id: 1340,
              nodeType: "Block",
              src: "1572:199:1",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                        id: 1320,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          arguments: [
                            {
                              id: 1314,
                              name: "tokenId",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 1306,
                              src: "1598:7:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            ],
                            id: 1313,
                            name: "ownerOf",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 402,
                            src: "1590:7:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_view$_t_uint256_$returns$_t_address_$",
                              typeString:
                                "function (uint256) view returns (address)",
                            },
                          },
                          id: 1315,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1590:16:1",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: "!=",
                        rightExpression: {
                          arguments: [
                            {
                              hexValue: "30",
                              id: 1318,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "1618:1:1",
                              typeDescriptions: {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0",
                              },
                              value: "0",
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0",
                              },
                            ],
                            id: 1317,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "1610:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)",
                            },
                            typeName: {
                              id: 1316,
                              name: "address",
                              nodeType: "ElementaryTypeName",
                              src: "1610:7:1",
                              typeDescriptions: {},
                            },
                          },
                          id: 1319,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1610:10:1",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        src: "1590:30:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        hexValue: "4e6f6e6578697374656e7420746f6b656e",
                        id: 1321,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1622:19:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_7003d7428552fca483d8ae514dcdd858508b192cded55eb84b078a27247ab7e4",
                          typeString: 'literal_string "Nonexistent token"',
                        },
                        value: "Nonexistent token",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_7003d7428552fca483d8ae514dcdd858508b192cded55eb84b078a27247ab7e4",
                          typeString: 'literal_string "Nonexistent token"',
                        },
                      ],
                      id: 1312,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [4294967278, 4294967278],
                      referencedDeclaration: 4294967278,
                      src: "1582:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 1322,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1582:60:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 1323,
                  nodeType: "ExpressionStatement",
                  src: "1582:60:1",
                },
                {
                  assignments: [1325],
                  declarations: [
                    {
                      constant: false,
                      id: 1325,
                      mutability: "mutable",
                      name: "currentBaseURI",
                      nameLocation: "1666:14:1",
                      nodeType: "VariableDeclaration",
                      scope: 1340,
                      src: "1652:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string",
                      },
                      typeName: {
                        id: 1324,
                        name: "string",
                        nodeType: "ElementaryTypeName",
                        src: "1652:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage_ptr",
                          typeString: "string",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 1328,
                  initialValue: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 1326,
                      name: "_baseURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [1362],
                      referencedDeclaration: 1362,
                      src: "1683:8:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_internal_view$__$returns$_t_string_memory_ptr_$",
                        typeString: "function () view returns (string memory)",
                      },
                    },
                    id: 1327,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1683:10:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1652:41:1",
                },
                {
                  expression: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      id: 1335,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          arguments: [
                            {
                              id: 1331,
                              name: "currentBaseURI",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 1325,
                              src: "1716:14:1",
                              typeDescriptions: {
                                typeIdentifier: "t_string_memory_ptr",
                                typeString: "string memory",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_string_memory_ptr",
                                typeString: "string memory",
                              },
                            ],
                            id: 1330,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "1710:5:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_bytes_storage_ptr_$",
                              typeString: "type(bytes storage pointer)",
                            },
                            typeName: {
                              id: 1329,
                              name: "bytes",
                              nodeType: "ElementaryTypeName",
                              src: "1710:5:1",
                              typeDescriptions: {},
                            },
                          },
                          id: 1332,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1710:21:1",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_bytes_memory_ptr",
                            typeString: "bytes memory",
                          },
                        },
                        id: 1333,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "1732:6:1",
                        memberName: "length",
                        nodeType: "MemberAccess",
                        src: "1710:28:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      nodeType: "BinaryOperation",
                      operator: ">",
                      rightExpression: {
                        hexValue: "30",
                        id: 1334,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1741:1:1",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0",
                        },
                        value: "0",
                      },
                      src: "1710:32:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    falseExpression: {
                      hexValue: "",
                      id: 1337,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "string",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1762:2:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                        typeString: 'literal_string ""',
                      },
                      value: "",
                    },
                    id: 1338,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "1710:54:1",
                    trueExpression: {
                      id: 1336,
                      name: "currentBaseURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1325,
                      src: "1745:14:1",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string memory",
                      },
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory",
                    },
                  },
                  functionReturnParameters: 1311,
                  id: 1339,
                  nodeType: "Return",
                  src: "1703:61:1",
                },
              ],
            },
            functionSelector: "c87b56dd",
            id: 1341,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "tokenURI",
            nameLocation: "1449:8:1",
            nodeType: "FunctionDefinition",
            overrides: {
              id: 1308,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "1527:8:1",
            },
            parameters: {
              id: 1307,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1306,
                  mutability: "mutable",
                  name: "tokenId",
                  nameLocation: "1466:7:1",
                  nodeType: "VariableDeclaration",
                  scope: 1341,
                  src: "1458:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 1305,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1458:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1457:17:1",
            },
            returnParameters: {
              id: 1311,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1310,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 1341,
                  src: "1553:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 1309,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "1553:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1552:15:1",
            },
            scope: 1363,
            src: "1440:331:1",
            stateMutability: "view",
            virtual: true,
            visibility: "public",
          },
          {
            body: {
              id: 1352,
              nodeType: "Block",
              src: "1840:33:1",
              statements: [
                {
                  expression: {
                    id: 1350,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 1348,
                      name: "baseURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1207,
                      src: "1850:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_string_storage",
                        typeString: "string storage ref",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 1349,
                      name: "newURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1343,
                      src: "1860:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_string_calldata_ptr",
                        typeString: "string calldata",
                      },
                    },
                    src: "1850:16:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  id: 1351,
                  nodeType: "ExpressionStatement",
                  src: "1850:16:1",
                },
              ],
            },
            functionSelector: "55f804b3",
            id: 1353,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 1346,
                kind: "modifierInvocation",
                modifierName: {
                  id: 1345,
                  name: "onlyOwner",
                  nameLocations: ["1830:9:1"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 1410,
                  src: "1830:9:1",
                },
                nodeType: "ModifierInvocation",
                src: "1830:9:1",
              },
            ],
            name: "setBaseURI",
            nameLocation: "1786:10:1",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 1344,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1343,
                  mutability: "mutable",
                  name: "newURI",
                  nameLocation: "1813:6:1",
                  nodeType: "VariableDeclaration",
                  scope: 1353,
                  src: "1797:22:1",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_string_calldata_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 1342,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "1797:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1796:24:1",
            },
            returnParameters: {
              id: 1347,
              nodeType: "ParameterList",
              parameters: [],
              src: "1840:0:1",
            },
            scope: 1363,
            src: "1777:96:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            baseFunctions: [473],
            body: {
              id: 1361,
              nodeType: "Block",
              src: "1954:31:1",
              statements: [
                {
                  expression: {
                    id: 1359,
                    name: "baseURI",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 1207,
                    src: "1971:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  functionReturnParameters: 1358,
                  id: 1360,
                  nodeType: "Return",
                  src: "1964:14:1",
                },
              ],
            },
            id: 1362,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_baseURI",
            nameLocation: "1888:8:1",
            nodeType: "FunctionDefinition",
            overrides: {
              id: 1355,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "1921:8:1",
            },
            parameters: {
              id: 1354,
              nodeType: "ParameterList",
              parameters: [],
              src: "1896:2:1",
            },
            returnParameters: {
              id: 1358,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 1357,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 1362,
                  src: "1939:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 1356,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "1939:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1938:15:1",
            },
            scope: 1363,
            src: "1879:106:1",
            stateMutability: "view",
            virtual: true,
            visibility: "internal",
          },
        ],
        scope: 1364,
        src: "341:1646:1",
        usedErrors: [],
      },
    ],
    src: "32:1956:1",
  },
  functionHashes: {
    "approve(address,uint256)": "095ea7b3",
    "balanceOf(address)": "70a08231",
    "baseURI()": "6c0360eb",
    "getApproved(uint256)": "081812fc",
    "getMaxSupply()": "4c0f38c2",
    "isApprovedForAll(address,address)": "e985e9c5",
    "mint(address,uint256)": "40c10f19",
    "minter()": "07546172",
    "name()": "06fdde03",
    "nextOwnerToExplicitlySet()": "d7224ba0",
    "originalTokenId(uint256)": "2a18624f",
    "owner()": "8da5cb5b",
    "ownerOf(uint256)": "6352211e",
    "renounceOwnership()": "715018a6",
    "safeTransferFrom(address,address,uint256)": "42842e0e",
    "safeTransferFrom(address,address,uint256,bytes)": "b88d4fde",
    "setApprovalForAll(address,bool)": "a22cb465",
    "setBaseURI(string)": "55f804b3",
    "setMaxSupply(uint256)": "6f8b44b0",
    "setMinter(address)": "fca3b5aa",
    "supportsInterface(bytes4)": "01ffc9a7",
    "symbol()": "95d89b41",
    "tokenByIndex(uint256)": "4f6ccce7",
    "tokenOfOwnerByIndex(address,uint256)": "2f745c59",
    "tokenURI(uint256)": "c87b56dd",
    "totalSupply()": "18160ddd",
    "transferFrom(address,address,uint256)": "23b872dd",
    "transferOwnership(address)": "f2fde38b",
  },
  gasEstimates: {
    creation: {
      codeDepositCost: "1550600",
      executionCost: "infinite",
      totalCost: "infinite",
    },
    external: {
      "approve(address,uint256)": "infinite",
      "balanceOf(address)": "2652",
      "baseURI()": "infinite",
      "getApproved(uint256)": "4678",
      "getMaxSupply()": "infinite",
      "isApprovedForAll(address,address)": "infinite",
      "mint(address,uint256)": "infinite",
      "minter()": "2428",
      "name()": "infinite",
      "nextOwnerToExplicitlySet()": "2339",
      "originalTokenId(uint256)": "2484",
      "owner()": "2420",
      "ownerOf(uint256)": "infinite",
      "renounceOwnership()": "28184",
      "safeTransferFrom(address,address,uint256)": "infinite",
      "safeTransferFrom(address,address,uint256,bytes)": "infinite",
      "setApprovalForAll(address,bool)": "26670",
      "setBaseURI(string)": "infinite",
      "setMaxSupply(uint256)": "2576",
      "setMinter(address)": "26821",
      "supportsInterface(bytes4)": "612",
      "symbol()": "infinite",
      "tokenByIndex(uint256)": "2567",
      "tokenOfOwnerByIndex(address,uint256)": "infinite",
      "tokenURI(uint256)": "infinite",
      "totalSupply()": "2371",
      "transferFrom(address,address,uint256)": "infinite",
      "transferOwnership(address)": "28400",
    },
    internal: {
      "_baseURI()": "infinite",
    },
  },
};
